import React from 'react';

import { type CollectionChainType } from '@app/client';
import { getCryptoCode } from '@app/floorGame';

import { Code, Price, StyledMilestone } from './styles';

export interface MilestoneProps {
    chain?: CollectionChainType;
    price?: number;
    sticky?: boolean;
}

export function Milestone({ chain, price = 0, sticky = false }: MilestoneProps) {
    const code = getCryptoCode(chain);

    return (
        <StyledMilestone $sticky={sticky}>
            <Price>{price}</Price>
            <Code>{code}</Code>
        </StyledMilestone>
    );
}
